import moment from "moment";

const RAW_DATA_FIELDS = [
  "Phone",
  "Swift Code/Routing",
  "Account Number",
  "Employee ID",
  "Passport #",
  "ID/Drivers License #/NI #",
  "Zip Code",
  "Permanent Zip Code",
  "Phone Number (mobile)",
  "Phone Number (landline)",
  "Emergency Contact Number",
  "Provident Fund (PF) Number",
  "Medical Insurance Policy Number",
  "PRAN number for NPS (if any)",
  "PAN Number",
  "Aadhar Number",
  "UAN Number",
  "Social Security #",
  "National ID #",
  "PW UAN Number",
  "Secondary Zip Code"
].map((f) => f.toLowerCase());

export const DATE_FIELDS = [
  "Date of Confirmation",
  "Date of Joining",
  "Date of Birth",
  "Last Hire Date",
  "Contract end date",
  "Contract Start Date",
  "NDA expiration date (if applicable)"
];

/* Accepted File Types: CSV, XLSX or other valid types supported in SpreadSheets. */
function excelFileReadHelper(event, onSuccess) {
  const content = event.target.result;
  import("xlsx")
    .then((XLSX) => {
      const workbook = XLSX.read(content, {
        type: "binary",
        cellDates: true,
        cellText: true,
        cellNF: false,
        // dateNF: "dd-mm-yyyy",
      });

      return workbook.SheetNames.map((sheetName) => {
        const sheet = workbook.Sheets[sheetName];
        const rowData = XLSX.utils.sheet_to_json(sheet, {
          header: true,
          defval: "",
          // dateNF: "mm/dd/yyyy",
          raw: false,
          rawNumbers: true,
        });

        const pickDateFromW = rowData.map((row, rowIndex) => {
          Object.keys(row).forEach((key, keyIndex) => {
            if (DATE_FIELDS.includes(key.trim())) {
              const cellRef = XLSX.utils.encode_cell({ c: keyIndex, r: rowIndex + 1 });
              const cell = sheet[cellRef];
              if (cell && cell.t === 'd' && cell.w) {
                  const actualYear = cell.v.getFullYear(); // Get full year from Date object
                  row[key] = cell.w.replace(/\b(\d{2})\b$/, actualYear.toString()); // Replace yy with yyyy;
              }
            }
          });
          return row;
        });

        // Now, parse the dates using Moment.js
        const parsedRowData = pickDateFromW.map(row => {
          const newRow = { ...row }; // Create a copy so you don't modify the original

          DATE_FIELDS.forEach(field => {
            if (newRow[field]) {
              const dateValue = newRow[field];

              // Check if it's a number (Excel date representation)
              if (typeof dateValue === 'number') {
                // Convert Excel serial date to a moment object
                const momentDate = moment(dateValue, 'DD-MM-YYYY'); //moment(dateValue, 'YYYY-MM-DD');
                if (momentDate.isValid()) {
                  newRow[field] = momentDate.format('MM-DD-YYYY'); // Format as desired
                } else {
                  console.warn(`Invalid date number: ${dateValue} for field ${field}`);
                  newRow[field] = "Invalid Date"; // Or handle the error as needed
                }
              } else if (typeof dateValue === 'string') {
                // It's already a string, try parsing with different formats if needed
                const momentDate = moment(dateValue, ['DD-MM-YYYY', 'YYYY-MM-DD', 'MM-DD-YYYY', 'MMM DD, YYYY']); // Add more formats
                if (momentDate.isValid()) {
                  newRow[field] = momentDate.format('MM-DD-YYYY'); // Format as desired
                } else {
                  console.warn(`Invalid date string: ${dateValue} for field ${field}`);
                  newRow[field] = "Invalid Date"; // Or handle the error as needed
                }

              } else {
                console.warn(`Invalid date type: ${typeof dateValue} for field ${field}`);
                newRow[field] = "Invalid Date";
              }
            }
          });

          return newRow;
        });
        // Restore raw data for specific fields from the import file to preserve leading zeros.
        // e.g. 0000011 should remain 0000011 instead of being converted to 11.
        const formattedData = parsedRowData.map((row, rowIndex) => {
          Object.keys(row).forEach((key, keyIndex) => {
            if (RAW_DATA_FIELDS.includes(key.trim().toLowerCase())) {
              const cellRef = XLSX.utils.encode_cell({ c: keyIndex, r: rowIndex + 1 });
              row[key] = sheet[cellRef] && sheet[cellRef].w ? sheet[cellRef].w : row[key];
            }
          });
          return row;
        });

        formattedData?.forEach(row => {
          Object.keys(row).forEach(key => {
            if (typeof row[key] === 'string') {
              row[key] = row[key].replace(/<[^>]*>?/gm, '');
            }
          });
        });
        return formattedData;
      });
    })
    .then((res) => {
      onSuccess(res);
    });
}

function getSupportedFileReader(fileType) {
  switch (fileType) {
    case "csv":
    case "xlsx":
      return excelFileReadHelper;
    default:
  }

  return null;
}

export function fileReadUtil(selectedFile, fileType) {
  return new Promise((onSuccess, onFailure) => {
    const fileReadHelper = getSupportedFileReader(fileType);
    try {
      if (fileReadHelper) {
        const fileReader = new FileReader();
        fileReader.onload = (event) => fileReadHelper(event, onSuccess);
        fileReader.readAsBinaryString(selectedFile);
      } else {
        onFailure("File type not supported");
      }
    } catch (err) {
      onFailure("File not readable");
    }
  });
}
